<div class="gridster">
  <gridstack *ngIf="gridOptions" [options]="gridOptions" (changeCB)="onGridChange($event)" (resizeStopCB)="onGridResize($event)">
  </gridstack>
</div>
